import {
  createBatchApi,
  createLineApi,
  deleteLineApi,
  getBatchApi,
  listBatchesApi,
  updateLineApi,
} from './apiClient'
import type {
  DemandBatch,
  DemandBatchCreateInput,
  DemandBatchDetail,
  DemandLine,
  DemandLineCreateInput,
  DemandLinePatchInput,
} from './types'

export const demandService = {
  list(): Promise<DemandBatch[]> {
    return listBatchesApi()
  },
  getById(id: string): Promise<DemandBatchDetail | null> {
    return getBatchApi(id)
  },
  create(input: DemandBatchCreateInput): Promise<DemandBatch> {
    return createBatchApi(input)
  },
  createLine(
    batchId: string,
    input: DemandLineCreateInput,
  ): Promise<DemandLine> {
    return createLineApi(batchId, input)
  },
  updateLine(
    batchId: string,
    lineId: string,
    patch: DemandLinePatchInput,
  ): Promise<DemandLine> {
    return updateLineApi(batchId, lineId, patch)
  },
  deleteLine(batchId: string, lineId: string): Promise<void> {
    return deleteLineApi(batchId, lineId)
  },
}

export type {
  AssemblyType,
  DemandBatch,
  DemandBatchCreateInput,
  DemandBatchDetail,
  DemandLine,
  DemandLineCreateInput,
  DemandLinePatchInput,
  IstaLevel,
} from './types'
export { PACKAGING_PAIR_OPTIONS } from './types'
export {
  DemandApiClientError,
  listBatchesApi,
  getBatchApi,
  createBatchApi,
  createLineApi,
  updateLineApi,
  deleteLineApi,
  pushSalesOrdersToDemandApi,
  type PushSalesOrdersToDemandInput,
  type PushSalesOrdersToDemandResult,
} from './apiClient'
